/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartData } from "../data/useChartData";
import { useTableData } from "../data/useTableData";
import { useHighchartTransformer } from "../transformers/useHighchartTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useParameter, useSubscriptionSource } from "../../../shared";
import { useExportSource } from "../hooks/useExportSource";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { debounceTime } from "rxjs/operators";

export const ComponentChart: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResultChart = useHookSubscribe(null, context.olapResultChart$);
  const olapResultTable = useHookSubscribe(null, context.olapResultTable$);
  const source = useHookSubscribe(null, context.sources$);
  useExportSource(source);
  useSubscriptionSource(source);

  const setHighlight = React.useCallback((selection: Record<string, number> | null) => {
    context.highlight = selection;
  }, []);

  const chartData = useChartData(olapResultChart);
  const tableData = useTableData(olapResultTable);
  const highchartData = useHighchartTransformer(chartData, tableData, setHighlight);

  if (window["exportMode"]) {
    window["exportReady"] = highchartData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (!source || !highchartData || context.readyState === ComponentContextReadyState.Loading) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentTitle>Producer prices (USD/MT)</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
    </>
  );
};
